import React from "react";

const currentYear = new Date().getFullYear();

function Footer() {
  return (
    <div>
      <div className="footer">
        <div className="copyright">
          <p>
            Copyright © {currentYear}{" "}
            <a href="https://codescap.com/" target="_blank" rel="noreferrer">
              Codescap
            </a>{" "}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
